import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('ApiUrlToken');
export const CALCULATION_URL = new InjectionToken<string>(
	'CalculationUrlToken',
);
export const EXPORT_URL = new InjectionToken<string>('ExportUrlToken');
export const IMPORT_URL = new InjectionToken<string>('ImportUrlToken');
export const INSIGHTS_URL = new InjectionToken<string>('InsightsUrlToken');
